{
  class animateOnScroll extends HTMLElement {
    constructor(){
      super()
      this.loaded = false
      this.played = false
    }

    connectedCallback() {
      if(!this.hasAttribute('animation')){
        this.setAttribute('animation', 'none')
      }

      if(this.loaded || window.coolHelperFunctions.prefersReducedMotion() || this.getAttribute('animation') == 'none'){
        return false
      } else {
        this.loaded = true
      }

      // admin preview hack fix because gutenberg doesn't like custom elements
      if(this.hasAttribute('className')){
        this.classList = this.getAttribute('className')
        this.removeAttribute('className')
      }      

      //do this when elements enter the screen
      const pxVisibleToAnimate = this.getAttribute('px-visible') || 100
      const threshold = this._calculateThreshold(pxVisibleToAnimate)
      const observer_in = new IntersectionObserver(entries => {
        const entry = entries[0]

        if(entry.intersectionRatio < threshold && this.originalHeight == this.offsetHeight){
          return;
        } else if(entry.intersectionRatio < threshold && this.originalHeight != this.offsetHeight){
          // this content has been changed since observing... allow the animation to fire early just in case the original threshold doesn't work anymore
        } 

        if(entry.isIntersecting === true && !this.played){
          this.played = true
          this.playEnterAnimation()

          if(this.hasAttribute('group')){
            document.querySelectorAll(`animate-on-scroll[group="${this.getAttribute('group')}"]`).forEach(el => {
              if(!el.played){
                el.played = true
                el.playEnterAnimation()
              }
            })
          }
        }
      }, { threshold: [ 0.001, threshold ] })

      setTimeout(() => observer_in.observe(this))
    }


    playEnterAnimation(){
      let delay = this.getAttribute('delay') || 100
      const speed = this.getAttribute('speed') || 500

      if(delay == 0){
        delay = 10
      }        
      const anim = this.getAttribute('animation')

      this._initAnimationStyles(this)

      setTimeout(() => {
        let path = ''

        //this resets a clip path to cover the full area
        if(anim == 'wipe-left' || anim == 'wipe-right' || anim == 'wipe-up' || anim == 'wipe-down' ){
          path = 'polygon(0 0, 100% 0, 100% 100%, 0 100%)'
        }
        this.style.transform = ''
        this.style.opacity = 1
        this.style.clipPath = path
        this.style.transition = `opacity ${speed}ms ease-in-out, transform ${speed}ms ease-in-out, clip-path ${speed}ms ease-in-out`
      }, delay)
    }

    _calculateThreshold(pxVisible){
      return Math.min(pxVisible / this.offsetHeight, 1)
    }

    _getAnimationByScreenQuery(target){
      let animation = target.getAttribute('animation')

      Array.from(this.attributes).forEach(a => {
        if(a.name.indexOf("animation-") !== -1){
          const width = parseInt(a.name.replace("animation-", ""))
          if(window.innerWidth <= width){
            animation = a.value
          }
        }
      })

      return animation
    }

    _initAnimationStyles(target){
      const distance = target.hasAttribute('distance') ? target.getAttribute('distance') : 100
      
      switch(this._getAnimationByScreenQuery(target)){
        case 'up': 
          setTimeout(() => {
            target.style.transform = `translate3d(0, ${distance}px, 0)`
          })
          break
        case 'down': 
          setTimeout(() => {
            target.style.transform = `translate3d(0, -${distance}px, 0)`
          })
          break
        case 'left': 
          setTimeout(() => {
            target.style.transform = `translate3d(-${distance}px, 0, 0)`
          })
          break
        case 'right': 
          setTimeout(() => {
            target.style.transform = `translate3d(${distance}px, 0, 0)`
          })
          break
        case 'scale': 
          setTimeout(() => {
            target.style.transform = 'scale(0.65)'
          })
          break
        case 'wipe-left':
          setTimeout(() => {
            target.style.clipPath = 'polygon(100% 0, 100% 0, 100% 100%, 100% 100%)'
          })
          break
        case 'wipe-right':
          setTimeout(() => {
            target.style.clipPath = 'polygon(0 0, 0 0, 0 100%, 0 100%)'
          })
          break 
        case 'wipe-down':
          setTimeout(() => {
            target.style.clipPath = 'polygon(0 0, 100% 0, 100% 0, 0 0)'
          })
          break 
        case 'wipe-up':
          setTimeout(() => {
            target.style.clipPath = 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)'
          })
          break    
      }
    }
  }

  customElements.define('animate-on-scroll', animateOnScroll)
}